const REASONING_LABELS = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  xhigh: 'Extra High',
  max: 'Max'
};

// Thinking levels as picker options, for Pieve's models and for the person's plan models alike.
const toModelReasoningOptions = (levels = []) => {
  return (Array.isArray(levels) ? levels : []).map((level) => ({ value: level, label: REASONING_LABELS[level] || level }));
};

export default toModelReasoningOptions;
